import { module as BaseModule } from "modujs";
import { createElement } from "react";
import { createRoot } from "react-dom/client";
import HeaderMoreNavigationComponent from "../components/HeaderMoreNavigation.jsx";

export default class HeaderMoreNavigation extends BaseModule {
  init() {
    this.rootEl =
      this.el.querySelector("[data-header-more-navigation-target]") ||
      this.el;
    this.props = { ...this.parseProps(), mountEl: this.rootEl };
    this.mountReact();
  }

  parseProps() {
    const rawProps = this.el.getAttribute(
      "data-header-more-navigation-props",
    );

    const baseProps = { items: [] };

    if (!rawProps) {
      return baseProps;
    }

    try {
      const parsed = JSON.parse(rawProps);
      return { ...baseProps, ...parsed };
    } catch (error) {
      console.warn("Failed to parse more navigation props:", error);
      return baseProps;
    }
  }

  mountReact() {
    if (!this.rootEl) {
      return;
    }

    if (!this.reactRoot) {
      this.reactRoot = createRoot(this.rootEl);
    }

    this.reactRoot.render(
      createElement(HeaderMoreNavigationComponent, this.props),
    );
  }

  destroy() {
    if (this.reactRoot) {
      this.reactRoot.unmount();
      this.reactRoot = null;
    }

    this.rootEl = null;
    this.props = null;
  }
}
